var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 701.2 441.3",
    enableBackground: "new 0 0 701.2 441.3",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#1A1A1A",
    points: "57.1,424.7 43.2,384.2 36,384.2 22.1,424.7 8.5,384.2 0,384.2 18.7,439.6 24.8,439.6 39.6,396.9  54.3,439.6 60.6,439.6 79.2,384.2 70.7,384.2  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135,
    y: 384,
    fill: "#1A1A1A",
    width: 8.8,
    height: 55.7
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#1A1A1A",
    points: "247.9,423.1 212.7,384.2 208.2,384.2 208.2,439.6 216.7,439.6 216.7,400.8 251.9,439.6  256.4,439.6 256.4,384.2 247.9,384.2  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1A1A1A",
    d: "M344.2,405.3c-5.8,0-10.2-0.5-13-1.4c-2.8-0.9-4.3-2.7-4.3-5.3c0-2.3,1.2-4.2,3.7-5.7 c2.4-1.5,5.9-2.2,10.3-2.2c3.5,0,7.3,0.6,11.2,1.9c3.9,1.2,7.7,3.1,11.4,5.5l4.4-7.2c-8.4-5.4-17.4-8.1-26.8-8.1 c-7.2,0-12.8,1.5-16.8,4.5c-4,3-6,6.8-6,11.4c0,2.9,0.6,5.3,1.7,7.2c1.1,1.9,2.9,3.3,5.1,4.4c2.3,1.1,5,1.8,8.3,2.2 c3.3,0.4,7,0.6,11.3,0.7c5.8,0.2,10.2,1,13,2.5c2.8,1.5,4.3,3.8,4.3,7.1c0,3-1.4,5.6-4.3,7.6c-2.9,2.1-6.9,3.1-12.2,3.1 c-4,0-8.2-0.7-12.7-2.1c-4.5-1.4-8.7-3.4-12.7-6l-4.3,7.3c4.5,2.8,9.4,5,14.7,6.5c5.3,1.5,10.6,2.3,15.9,2.3 c3.8,0,7.2-0.5,10.3-1.5c3.1-1,5.6-2.3,7.8-3.9c2.1-1.6,3.7-3.6,4.8-5.8c1.1-2.2,1.7-4.6,1.7-7C370.9,411.2,362,405.3,344.2,405.3z "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#1A1A1A",
    points: "421.3,391.9 444.7,391.9 444.7,439.6 453.2,439.6 453.2,391.9 476.5,391.9 476.5,384.2  421.3,384.2  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1A1A1A",
    d: "M584.2,391.1c-3-2.6-6.5-4.7-10.7-6.2c-4.2-1.5-8.8-2.3-14-2.3c-5,0-9.7,0.8-13.8,2.3 c-4.2,1.5-7.7,3.6-10.7,6.2c-3,2.6-5.3,5.7-6.9,9.3c-1.6,3.6-2.5,7.4-2.5,11.5c0,4.1,0.8,7.9,2.5,11.5c1.6,3.6,3.9,6.7,6.9,9.4 c3,2.7,6.5,4.7,10.7,6.2c4.2,1.5,8.8,2.3,13.8,2.3c5.1,0,9.8-0.8,14-2.3c4.2-1.5,7.7-3.6,10.7-6.2c3-2.7,5.3-5.8,6.9-9.3 c1.6-3.5,2.5-7.4,2.5-11.6c0-4.2-0.8-8-2.5-11.6C589.5,396.8,587.2,393.7,584.2,391.1z M583,420.3c-1.2,2.6-2.8,4.9-5,6.8 c-2.2,1.9-4.9,3.4-8,4.5c-3.1,1.1-6.6,1.7-10.4,1.7c-3.8,0-7.2-0.6-10.3-1.7c-3.1-1.1-5.7-2.6-7.8-4.5c-2.2-1.9-3.9-4.2-5-6.7 c-1.2-2.6-1.8-5.4-1.8-8.4c0-3,0.6-5.8,1.8-8.4c1.2-2.6,2.9-4.8,5-6.7c2.2-1.9,4.8-3.4,7.8-4.5c3.1-1.1,6.5-1.7,10.3-1.7 c3.8,0,7.3,0.6,10.4,1.7c3.1,1.1,5.7,2.6,7.9,4.5c2.2,1.9,3.9,4.2,5,6.8c1.2,2.6,1.8,5.4,1.8,8.3 C584.7,414.9,584.1,417.7,583,420.3z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#1A1A1A",
    points: "692.7,384.2 692.7,423.1 657.5,384.2 653,384.2 653,439.6 661.5,439.6 661.5,400.8 696.7,439.6  701.2,439.6 701.2,384.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#1A1A1A",
    points: "350.6,83.8 146.5,0 283.7,256.3 350.6,101.6 417.5,256.3 554.7,0  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBlack);
export default __webpack_public_path__ + "static/media/logo-black.88c3e8697df042d59967b1ef62c205ac.svg";
export { ForwardRef as ReactComponent };